/**
 * Quality / rendition management API.
 * Auto (-1) vs manual level selection. Bandwidth monitoring is pluggable.
 */
export function createQualityManager(options) {
  options = options || {};
  var levels = [];
  var currentLevel = -1; // -1 = auto
  var mode = "auto"; // auto | manual
  var estimatedBandwidth = 0;
  var listeners = [];

  function notify(event, payload) {
    for (var i = 0; i < listeners.length; i++) {
      try {
        listeners[i](event, payload);
      } catch (e) {
        /* ignore */
      }
    }
  }

  return {
    /**
     * @param {object[]} nextLevels
     */
    setAvailableLevels: function (nextLevels) {
      levels = Array.isArray(nextLevels) ? nextLevels.slice() : [];
      notify("levels", levels);
    },

    getAvailableLevels: function () {
      return levels.slice();
    },

    getCurrentLevel: function () {
      return currentLevel;
    },

    getMode: function () {
      return mode;
    },

    /**
     * @param {number} index  -1 for auto
     * @param {function} [applyFn] called with index to push into streaming provider
     */
    selectLevel: function (index, applyFn) {
      if (index === -1) {
        mode = "auto";
        currentLevel = -1;
      } else {
        mode = "manual";
        currentLevel = index;
      }
      if (typeof applyFn === "function") {
        applyFn(currentLevel);
      }
      notify("change", {
        mode: mode,
        level: currentLevel,
        levels: levels,
      });
    },

    setAuto: function (applyFn) {
      this.selectLevel(-1, applyFn);
    },

    /**
     * Called when the streaming provider switches levels (auto ABR).
     * @param {number} index
     */
    reportLevelSwitched: function (index) {
      currentLevel = index;
      notify("change", {
        mode: mode,
        level: currentLevel,
        levels: levels,
        fromProvider: true,
      });
    },

    /**
     * Future: feed from network monitor.
     * @param {number} bps
     */
    setEstimatedBandwidth: function (bps) {
      estimatedBandwidth = bps || 0;
      notify("bandwidth", estimatedBandwidth);
    },

    getEstimatedBandwidth: function () {
      return estimatedBandwidth;
    },

    getSnapshot: function () {
      var current = null;
      for (var i = 0; i < levels.length; i++) {
        if (levels[i].index === currentLevel) {
          current = levels[i];
          break;
        }
      }
      return {
        mode: mode,
        currentLevel: currentLevel,
        current: current,
        levels: levels.slice(),
        estimatedBandwidth: estimatedBandwidth,
        resolution: current
          ? { width: current.width || 0, height: current.height || 0 }
          : null,
      };
    },

    subscribe: function (fn) {
      listeners.push(fn);
      return function () {
        listeners = listeners.filter(function (f) {
          return f !== fn;
        });
      };
    },

    destroy: function () {
      levels = [];
      listeners = [];
    },
  };
}

export default createQualityManager;
